export default "__VITE_ASSET__ul$aOxeN__"